import { useRecord, UseRecordOptions } from "./useRecord";

export function useDraft(draftId?: string | null, options?: UseRecordOptions) {
  return useRecord("draft", draftId, { name: "useDraft", ...options });
}
